import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Group, PagedData } from '../models/general.models';

@Injectable({
  providedIn: 'root'
})
export class GroupService {
  private baseUrl: string = environment.baseUrl;

  constructor(private http: HttpClient) {}

  public getGroups(page: number): Observable<PagedData<Group>> {
    const endpoint = `${this.baseUrl}/groups/?page=${page}&limit=100`;
    return this.http.get<PagedData<Group>>(endpoint);
  }

  public searchGroup(
    search: string,
    page: number = 1
  ): Observable<Array<Group>> {
    const endpoint = `${this.baseUrl}/groups/search/?page=${page}&q=${search}`;
    return this.http.get<Array<Group>>(endpoint);
  }

  public createGroup(body: Group): Observable<Group> {
    const endpoint = `${this.baseUrl}/groups/`;
    return this.http.post<Group>(endpoint, body);
  }
}
